"use client";

import Footer from "@/components/organisms/footer";
import Header from "@/components/organisms/header";
import { motion } from "motion/react";

/**
 * Layout component for wrapping pages with a header, footer, and page transition effects.
 *
 * @component
 * @example
 * return (
 *   <Layout
 *     className="my-layout"
 *     isNavColorWhite={true}
 *     footerData={footerData}
 *   >
 *     <p>Page content here</p>
 *   </Layout>
 * )
 * @param {object} props - The props for the component.
 * @param {string} [props.className=''] - Additional classes for the layout.
 * @param {React.ReactNode} props.children - The content to be rendered inside the layout.
 * @param {React.CSSProperties} [props.style={}] - Inline styles for the layout.
 * @returns {JSX.Element} The layout component with page transition and fixed button.
 */
const Layout = ({
  isEventPage,
  settingAPI,
  footerAPI,
  className = "",
  children,
  style = {},
}) => {
  const pageTransition = {
    initial: { opacity: 0 },
    enter: {
      opacity: 1,
      transition: { duration: 0.3, delay: 0.1, ease: "easeOut" },
    },
    exit: {
      opacity: 0,
      pointerEvents: "none",
      transition: { duration: 0.2, ease: "easeIn" },
    },
  };

  return (
    <motion.main
      initial="initial"
      animate="enter"
      exit="exit"
      variants={pageTransition}
      className={`relative w-full min-h-[100svh] flex flex-col ${className}`}
      style={style}
    >
      <Header settingAPI={settingAPI} isEventPage={isEventPage} />
      {children}
      <Footer footerAPI={footerAPI} />
    </motion.main>
  );
};

export default Layout;
